import { useMemo } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import { usePageMeta } from "@/hooks/usePageMeta";
import { faqs } from "@/mocks/topics";
import Hero from "./components/Hero";
import LiveAndRanking from "./components/LiveAndRanking";
import CategoryGrid from "./components/CategoryGrid";
import HotTopics from "./components/HotTopics";
import ActiveBoard from "./components/ActiveBoard";
import FaqSection from "./components/FaqSection";
import SubscribeSection from "./components/SubscribeSection";

export default function Home() {
  const jsonLd = useMemo(
    () => [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: "17吃瓜社区",
        url: "https://17.cn/",
        description: "17吃瓜社区是中文娱乐话题讨论社区,热门话题实时滚动,网友边看边聊。",
        potentialAction: {
          "@type": "SearchAction",
          target: "https://17.cn/topics?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "17吃瓜社区",
        url: "https://17.cn/",
        email: "hello@17.cn",
        description: "专注娱乐话题的中文讨论社区,涵盖影视、综艺、舞台演出与网络热点。",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
    []
  );

  usePageMeta({
    title: "17吃瓜社区 - 热门话题实时滚动,网友边看边聊的讨论社区",
    description:
      "17吃瓜社区聚集大量网友讨论,影视、综艺、舞台演出与网络热点话题实时滚动。进17.cn参与评论互动,看不同角度的吃瓜观点,加入圈子一起聊。",
    keywords: "17.cn,17.cn吃瓜社区,17.cn网友讨论,17.cn评论互动,17.cn吃瓜圈子",
    path: "/",
    jsonLd,
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <LiveAndRanking />
        <CategoryGrid />
        <HotTopics />
        <ActiveBoard />
        <FaqSection />
        <SubscribeSection />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}